import { useCallback } from 'react'
import * as fcl from '@onflow/fcl'
import { Link, Text, Box, Divider, ListItem, UnorderedList } from 'src/theme'
import Button from 'src/components/Button'
import { useAnalytics } from 'src/lib/analytics'
import { useRedemptionMachine, getTrackPropertiesFromState } from '@dapperlabs/redeem.js'
import { formatDistance, format, differenceInYears } from 'date-fns'
import { Sanitized } from '../Sanitized'

const getCampaignDate = (d, distance = false) => {
  return distance
    ? formatDistance(d, new Date(), { addSuffix: true })
    : format(d, 'MMM dd, yyy @ hh:mm aaa O')
}

export default function CampaignDetails () {
  const { track } = useAnalytics()
  const [current, send] = useRedemptionMachine()
  const handleStart = useCallback(() => {
    track('redeem_start-click', getTrackPropertiesFromState(current))
    send('START')
  }, [current, send, track])

  const handleSignOut = useCallback(async () => {
    track('sign_out-click', getTrackPropertiesFromState(current))
    await fcl.unauthenticate()
    window.location.reload()
  }, [current, track])

  const campaign = current.context?.campaign
  const isExpired = campaign.dateEnd < new Date()
  const isInFuture = campaign.dateStart > new Date()
  const expiresInALongTime = differenceInYears(campaign.dateEnd, new Date(new Date().setFullYear(new Date().getFullYear() + 1))) >= 1


  return (
    <>
      <Box pl={2} pr={2} pb={4}>
        <Box mb={6} sx={{
          p: {
            mb: 3,
          },
          ul: {
            ml: 6,
            mb: 3,
          },
          a: {
            fontWeight: 'bold',
            color: 'rgb(50, 94, 255)'
          }
        }}>
          <Sanitized _dangerouslySetInnerHTML={campaign?.description} />
        </Box>
        {/* only render if expiration date is within a year OR if the campaign hasn't started yet */}
          { (!expiresInALongTime || isInFuture) && (
          <Text
            fontWeight={700}
            fontSize="sm"
          >
            {isInFuture
              ? `You're too early! This code will be redeemable ${getCampaignDate(campaign.dateStart)}`
              : isExpired
                ? 'This campaign has expired.'
                : `Expires ${getCampaignDate(campaign.dateEnd)}`
            }
          </Text>
        )}
        {campaign?.moreInfoUrl && (
          <Text mb={2} fontSize="sm">
            <Link
              href={campaign.moreInfoUrl}
              isExternal
            >
              Back to NBA Top Shot
            </Link>
          </Text>
        )}
      </Box>
      {(!isExpired && !isInFuture) && (
        <Button
          onClick={handleStart}
          disabled={isExpired || isInFuture}
          mb={1}
          colorScheme='purple'
        >
          {current.context.user ? 'Redeem now' : 'Sign in to redeem!'}
        </Button>
      )}
      {current?.context?.user && (
        <>
          <Divider mb={6} mt={6} />
          <Text fontSize="sm" textAlign={"center"}>
            Signed in as <b>{current?.context?.user?.addr ?? 'unknown'}</b>
            <br/>
            <Link onClick={handleSignOut}>
              Sign out
            </Link>
          </Text>
        </>
      )}
    </>
  )
}
